module.exports = __webpack_public_path__ + "static/media/EarthDayRecipeBook.b580b8d2.pdf";